import React from "react";
import { useNavigate } from "react-router-dom";

import { extractDate } from "../../../Components/Functions/date.fun";
const tableHead = [
  "id",
  "Call By/From",
  "source",
  "Call Date/Time",
  "duration",
  "answered / type",
  "phone book",
];

function checkDateStatus(dateString) {
  const inputDate = new Date(dateString);
  const currentDate = new Date();
  const differenceMilliseconds = currentDate - inputDate;
  const differenceDays = differenceMilliseconds / (1000 * 3600 * 24);

  if (differenceDays <= 1) {
    return "superhot";
  } else if (differenceDays > 1 && differenceDays <= 4) {
    return "hot";
  } else if (differenceDays > 4 && differenceDays <= 7) {
    return "warmer";
  } else if (differenceDays > 7 && differenceDays <= 10) {
    return "warm";
  } else if (differenceDays > 10 && differenceDays <= 13) {
    return "colder";
  } else {
    return "cold";
  }
}
const getBackgroundStyleByDate = (duration) => {
  let style = {};
  if (duration > 90) {
    style = {
      backgroundColor: "rgb(12, 166, 120,0.1)",
    };
    return style;
  } else if (duration > 30) {
    style = {
      backgroundColor: "rgb(116, 184, 22,0.1)",
    };
    return style;
  } else {
    style = {
      backgroundColor: "rgba(255,0,0,0.1)",
    };
    return style;
  }
};
const convertUtcToIst = (utc) => {
  const utcDate = new Date(utc); // Expecting ISO or valid UTC date string

  // Get IST time directly using Intl.DateTimeFormat
  const options = {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };

  const formatter = new Intl.DateTimeFormat("en-GB", options);
  const parts = formatter.formatToParts(utcDate);

  const getPart = (type) => parts.find((p) => p.type === type)?.value;

  const formattedDate = `${getPart("year")}-${getPart("month")}-${getPart(
    "day"
  )}`;
  const formattedTime = `${getPart("hour")}:${getPart("minute")}:${getPart(
    "second"
  )}`;

  return `${formattedDate} ${formattedTime}`;
};

function formatSecondsToHMS(seconds) {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  const pad = (n) => n.toString().padStart(2, "0");
  return `${pad(hrs)}:${pad(mins)}:${pad(secs)}`;
}

const CallTrackingTable = ({ callsData = [], ReassignLead }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/leads-followup/view/${id}`);
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => (
              <th key={index}>{item}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {callsData?.map((item, index) => {
            return (
              <tr
                key={item?.id}
                style={getBackgroundStyleByDate(item?.duration)}
              >
                <td>{item?.id}</td>
                <td>
                  <span>{item?.userName}</span>
                  <br />
                  <span>{item?.userPhone}</span>
                </td>

                <td>
                  <span>{item?.source}</span>
                  <br />
                  <span>{item?.sourceDetail}</span>
                </td>
                <td>{convertUtcToIst(item.startTime)}</td>

                <td>{formatSecondsToHMS(item?.duration)}</td>
                <td>
                  <span>{item?.answered ? "Answered" : "Not-Answered"}</span>
                  <br />
                  <span>{item?.inbound ? "Incommig" : "Outgoing"}</span>
                </td>
                <td>
                  <span>{item?.phonebookName}</span>
                  <br />
                  <span>{item?.formattedNumber || item?.number}</span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CallTrackingTable;
